//TODO: remove process.env.NEXT_PUBLIC_BFF_URL for server component;
export const API_URLS = {
  getPlaceDetails: '/api/location/place',
  getPlaceAutocomplete: '/api/location/place-autocomplete?query=#{query}',
  emailVerificationReInitiate: `/api/initiate-verification/verification-follow-up-initiate/#{parentCaseId}?telescopicAccessType=#{telescopicAccessType}`,
  getEmailVerifierComponentIdDetailsWithCaseId: `/api/initiate-verification/claim-case-details/#{parentCaseId}/#{caseId}?telescopicAccessType=#{telescopicAccessType}`,
  updateIaRequestedDetails:
    '/api/issuing-authority-update/update-ia-requested-details',
  getAllVerifierWithClaimId: `/api/issuing-authority-map/issuing-authority-verifier-list-from-claimid?claimId=#{claimId}`,
  getRBACPermissions: '/api/rbac/permissions',
  getRouteConfig: '/api/rbac/route-config',
  getIaPortalNavItems: '/config/iaVerifierPortalNavConfig',
  logOutUrl: `/api/onboarding/logout`,
  getActiveFeatureConfig: `/api/config/active-features`,
  getUserProfile: `/api/user`,
  getPlatformPreferenceForCoBrandDetails: `/api/config/platform-preferences?url=#{url}&platformType=#{platformType}`,
  getNationalityDetails: `/api/config/nationalities`,
  getUserById: `/api/user/#{userId}`,
  getMyDashboardDetails: `/api/dashboard-ops/details`,
  getCurrencyDetails: `/api/config/currency`,
  getAllCurrencyDetails: `/api/config/allCurrency`,
  getVendorDetail: '/api/vendor/details?vendorId=#{vendorId}',
  postVendorApprove: '/api/vendor/approve?vendorId=#{vendorId}',
  postVendorDeActivate: '/api/vendor/de-activate?vendorId=#{vendorId}',
  getUser: `/api/user`,
  getDashboardDetails: `/api/dashboard-ops/details?type=#{type}`,
  getReviewTasksDetails: `/api/dashboard-ops/review-tasks`,
  getApplicantDetails: `/api/validation/applicant-details?caseId=#{caseId}&followUpType=#{followUpType}`,
  getAppealErrorDetails: `/api/appeal-error-details?caseId=#{caseId}`,
  updateAppealErrorDetails: `/api/appeal-error-details/update`,
  updateClaim: '/api/validation/update-claim',
  assignReview:
    '/api/validation/assign-review?verificationRequestId=#{verificationRequestId}',
  processRequest: '/api/validation/process-request',
  getComponentDocument:
    '/api/validation/component-document?componentId=#{componentId}',
  updateFollowUp: '/api/followUp-case-details/update',
  getEmailVerifierComponentIdDetails: `/api/initiate-verification/claim-details?caseId=#{caseId}`,
  getEmailVerifierClaimComponentIdDetails: `/api/initiate-verification/claim-details?claimCaseId=#{claimCaseId}`, // TODO: remove this when skipAccessControl
  getFollowUpCaseDetails: `/api/followUp-case-details?caseId=#{caseId}`,
  getVerifierApplicantDetailsByClaim: `/api/initiate-verification/applicant-details?claimItemId=#{activeClaimItemId}&verifierId=#{verifierId}&cvcrId=#{cvcrId}`,
  getVerifierApplicantDetailsByToken: `/api/initiate-verification/bulk-applicant-details?token=#{id}&activeClaimItemId=#{activeClaimItemId}&emailChanged=#{emailChanged}&verifierEmail=#{verifierEmail}`,
  getApplicantPersonalInfo: `/api/initiate-verification/user-details?claimItemId=#{claimItemId}`,
  emailVerifierResponse: `/api/initiate-verification/verifier-response`,
  submitVerifierRequest: `/api/initiate-verification/submit-verifier-request?caseId=#{caseId}`,
  submitVerifierResponse: `/api/initiate-verification/submit-verifier-response`,
  getIssuingAuthorityRequiredData: `/api/initiate-verification/issuing-authority-required-data/#{claimItemId}`,
  getReportDetails: `/api/report/detail?caseId=#{caseId}`,
  publishReport: `/api/report/publish`,
  addReportResponse: `/api/report/reportqc-response`,
  uploadClaimProofURL: `/api/validation/upload-claim-proof?verificationRequestId=#{verificationRequestId}`,
  getQualityCheckDetails: `/api/verifier/qc-details?caseId=#{caseId}`,
  addQualityRemarksDetails: `/api/verifier/qc-update`,
  getSsoLoginUrl: '/api/ops/ssoLoginUrl?redirectUrl=#{redirectUrl}',
  ssoLogin: '/api/ops/ssoLogin?code=#{code}&redirectUrl=#{redirectUrl}',
  ssoLogOutUrl: `/api/ops/ssoLogOut`,
  notifications: '/api/notifications',
  updateReadStatus: '/api/notifications/updateReadStatus',
  notificationsStatus: '/api/notifications/getNotificationsStatus',
  getClientContractingEntities:
    '/api/create-client/getClientContractingEntities',
  getCountries: '/api/location/country',
  getStates: '/api/location/state',
  getCities: '/api/location/city',
  getNationalitiesConfig: '/api/config/nationalities',
  createClient: '/api/create-client/',
  getValidationBreadCrumbs:
    '/api/validation/breadcrumbs?verificationRequestId=#{verificationRequestId}',
  getVerificationBreadCrumbs:
    '/api/verification-details/breadcrumbs?claimItemId=#{claimItemId}',
  getIaDetails: '/api/create-vendor/get-ia-details?iaName=#{iaName}',
  getModeOfPaymentOptions: '/api/create-vendor/mode-of-payment-options',
  createVendor: '/api/create-vendor/create',
  createPartner: '/api/partner-onboarding/create-partner',
  getPartnerVerificationScope: '/api/partner-onboarding/client-contract',
  getPartnerType: '/api/partner-onboarding/partner-type',
  getIaListDetailsByName: `/api/ia-selection/list?name=#{name}`,
  getVendorDatabase: '/api/vendor/getAllVendors',
  reinitiateVerification: '/api/initiate-verification/reinitiate-verification',
  generateEmail: '/api/initiate-verification/auto-generate-email',
  sendEmailVerification: '/api/initiate-verification/send-email-verification',
  getVerificationDetailsByToken: `/api/initiate-verification/applicant-details?token=#{token}`,
  emailVerify: `/api/onboarding/ia-login/otp-verify`,
  iaLogin: `/api/onboarding/ia-login/otp`,
  setVerifier: `/api/onboarding/email/set-verifier?token=#{token}`,
  getEmailByToken: `/api/onboarding/email?token=#{token}`,
  getIaCompletedRequestsTableData: `/api/ia-verifier/completed-requests`,
  getIndividualClaimDocuments: `/api/ia-verifier/download-individual-claim?claimItemId=#{claimItemId}&claimType=#{claimType}`,
  getIaPendingRequestsTableData: `/api/ia-verifier/pending-requests`,
  getDownloadCsv: `/api/ia-verifier/download-csv?from=#{from}&to=#{to}`,
  translateObjectsList: '/api/translate/objects-list',
  translateDocumentsList: '/api/translate/documents-list',
  getVerificationDocumentByCaseId:
    '/api/initiate-verification/verification-document-by-claimId?caseId=#{caseId}',
  getCaseHistoryTimeline:
    '/api/get-case-history?caseId=#{caseId}&entityId=#{entityId}',
  errorLog: '/api/log',
  skipTask: `/api/task-allocation/skip-task`,
  setSelectedIaVerifier: `/api/ia-verifier/set-verifier?verifierId=#{verifierId}&profileAccessType=#{profileAccessType}`,
  getIaVerifiers: `/api/ia-verifier?profileAccessType=#{profileAccessType}`,
  getIssuingAuthorityAggregatorsOptions: `/api/initiate-verification/issuing-authority-aggregator`,
  generateVerifierToken: '/api/ia-verifier/digiflow-token',
  getIaVerifierFilterData: `/api/ia-verifier/filter-data`,
  getClaimVerificationStatus: `/api/ia-verifier/claim-verification-status?claimItemId=#{claimItemId}`,

  validateAutoLogin: '/api/auto-login/validate-ia?token=#{token}',
  generateMagicLink: '/api/auto-login/ia',
  validateCtaMagicCode: '/cta/resolve/'
} as const;

export const TEAM_MEMBER_ID = 'teamMemberId';
export const TEAM_MEMBERS_API = {
  getAllTeamMembers: '/api/team-member',
  getMetadata: '/api/team-member/metadata',
  getTeamMemberById: `/api/team-member/:${TEAM_MEMBER_ID}`,
  getTeamMemberByIdWithManager: `/api/team-member/#{${TEAM_MEMBER_ID}}?manager=true`,
  deleteMemberById: `/api/team-member/:${TEAM_MEMBER_ID}`,
  updateMemberById: `/api/team-member/:${TEAM_MEMBER_ID}`,
  createTeamMember: `/api/team-member`,
  getManagerList: '/api/team-member/manager',
  getIA: '/api/team-member/ia?synonym=#{synonym}'
};

export const DOCUMENT_UPLOAD_URL = `${process.env.NEXT_PUBLIC_DOCUMENT_SERVICE_URL}/upload`;
